/* Product-only adaptation of the existing mobile action; native form owns purchase. */
(() => {
  if (!document.body.classList.contains('ccf-template-product')) return;
  const bindSignupLayout = () => {
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const shadow = host.shadowRoot;
      if (!shadow || shadow.querySelector('[data-ccf-product-signup-placement]')) return;
      // Forms owns its open/close state inside this shadow root. Offset only
      // its floating teaser; the opened form keeps the app's native layout.
      const style = document.createElement('style');
      style.setAttribute('data-ccf-product-signup-placement', '');
      style.textContent = '@media(max-width:749px){#app-embed[data-current-step="tease"][data-layout="floating"]{left:12px!important;right:auto!important;bottom:calc(84px + env(safe-area-inset-bottom))!important;}}';
      shadow.appendChild(style);
    });
  };
  customElements.whenDefined('shopify-forms-embed').then(bindSignupLayout);
  const guardedForms = new WeakSet();
  const selectionMatches = info => {
    const picker = info?.querySelector('variant-selects');
    if (!picker) return true;
    try {
      const variant = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || 'null');
      const choices = Array.from(picker.querySelectorAll('select, fieldset input:checked')).map(input => input.value);
      const id = info.querySelector('product-form input[name="id"]')?.value;
      return !!variant?.available && String(variant.id) === id && choices.length === variant.options.length && choices.every((value, index) => value === variant.options[index]);
    } catch (_) { return false; }
  };
  const bindPurchaseGuard = () => {
    document.querySelectorAll('product-info product-form').forEach(form => {
      if (guardedForms.has(form) || typeof form.toggleSubmitButton !== 'function') return;
      guardedForms.add(form);
      const nativeToggle = form.toggleSubmitButton.bind(form);
      form.toggleSubmitButton = (disable = true, text) => {
        const info = form.closest('product-info');
        if (disable && !selectionMatches(info)) info.setAttribute('data-ccf-selection-stale', '');
        if (!disable && !selectionMatches(info)) {
          info.setAttribute('data-ccf-selection-stale', '');
          nativeToggle(true);
          form.handleErrorMessage("This choice couldn't load. Please choose another option or refresh the page.");
          return;
        }
        if (!disable && info.hasAttribute('data-ccf-selection-stale')) {
          info.removeAttribute('data-ccf-selection-stale');
          form.handleErrorMessage();
        }
        nativeToggle(disable, text);
      };
    });
  };
  const sync = () => {
    bindSignupLayout();
    bindPurchaseGuard();
    const card = document.querySelector('product-info .ccf-campaign-countdown[data-ccf-halloween-owned]');
    const priceWrapper = card?.closest('[id^="price-"]');
    // Dawn replaces this wrapper's contents on each variant change. Keep the
    // manager-owned card beside it so the same node survives and expires normally.
    if (priceWrapper) priceWrapper.insertAdjacentElement('afterend', card);
    const purchase = document.querySelector('product-info .product__info-container > div:has(> product-form)');
    const payment = purchase?.querySelector('.ccf-pay-trust--product');
    if (payment) purchase.insertAdjacentElement('afterend', payment);
    const gallery = document.querySelector('product-info .product__media-list');
    const activeMedia = gallery?.querySelector('.product__media-item.is-active .product-media-container');
    if (gallery && activeMedia) {
      const height = `${activeMedia.getBoundingClientRect().height}px`;
      if (gallery.style.getPropertyValue('--ccf-active-gallery-height') !== height) gallery.style.setProperty('--ccf-active-gallery-height', height);
    }
    const bar = document.querySelector('.ccf-mobile-buy');
    const button = document.querySelector('product-info .product-form__submit');
    const proxy = bar?.querySelector('button');
    if (proxy && button) {
      const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
      if (proxy.disabled !== disabled) proxy.disabled = disabled;
    }
  };
  new MutationObserver(sync).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
  window.addEventListener('resize', sync, {passive: true});
  document.addEventListener('slideChanged', sync);
  document.addEventListener('submit', event => {
    const form = event.target.closest('product-info product-form');
    if (!form) return;
    const info = form.closest('product-info');
    const button = form.querySelector('.product-form__submit');
    if (!selectionMatches(info) || button?.disabled || button?.getAttribute('aria-disabled') === 'true') {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!selectionMatches(info)) form.toggleSubmitButton(false);
    }
  }, true);
  document.addEventListener('click', event => {
    if (!event.target.closest('.ccf-mobile-buy button')) return;
    const button = document.querySelector('product-info .product-form__submit');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  sync();
})();
